import React, { useEffect, useRef } from "react";

const EMBED_SCRIPT_ID = "instagram-embed-js";
const EMBED_SCRIPT_SRC = "https://platform.instagram.com/en_US/embeds.js";

/** Visual shell before Instagram.js replaces content */
const blockquoteStyle = {
  background: "#FFF",
  border: 0,
  borderRadius: 3,
  boxShadow: "0 0 1px 0 rgba(0, 0, 0, 0.5), 0 1px 10px 0 rgba(0, 0, 0, 0.15)",
  margin: "1px auto",
  padding: 0,
};

/**
 * Meta’s official profile/post embed (blockquote + platform.instagram.com/embeds.js).
 * @param {string} permalink - e.g. https://www.instagram.com/gemfashionstudio/?utm_source=ig_embed&utm_campaign=loading
 */
export default function InstagramOfficialEmbed({ permalink }) {
  const hostRef = useRef(null);

  useEffect(() => {
    if (!permalink || !hostRef.current) return undefined;

    const process = () => {
      try {
        window.instgrm?.Embeds?.process();
      } catch (_) {
        /* ignore */
      }
    };

    const afterLoad = () => {
      requestAnimationFrame(process);
    };

    let existing = document.getElementById(EMBED_SCRIPT_ID);
    if (window.instgrm?.Embeds) {
      afterLoad();
      return undefined;
    }

    if (existing) {
      if (existing.getAttribute("data-loaded") === "1") {
        afterLoad();
      } else {
        existing.addEventListener("load", afterLoad, { once: true });
      }
      return undefined;
    }

    const s = document.createElement("script");
    s.id = EMBED_SCRIPT_ID;
    s.async = true;
    s.src = EMBED_SCRIPT_SRC;
    s.addEventListener("load", () => {
      s.setAttribute("data-loaded", "1");
      afterLoad();
    });
    document.body.appendChild(s);

    return undefined;
  }, [permalink]);

  if (!permalink) return null;

  return (
    <div ref={hostRef} className="instagram__oembedHost">
      <blockquote
        className="instagram-media instagram__embedBlockquote"
        data-instgrm-permalink={permalink}
        data-instgrm-version="14"
        style={blockquoteStyle}
      >
        <div style={{ padding: 16 }}>
          <a
            href={permalink}
            style={{
              background: "#FFFFFF",
              lineHeight: 0,
              padding: 0,
              textAlign: "center",
              textDecoration: "none",
              width: "100%",
              display: "block",
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div style={{ color: "#3897f0", fontFamily: "Arial,sans-serif", fontSize: 14, fontWeight: 550, lineHeight: "18px" }}>
              View this profile on Instagram
            </div>
          </a>
        </div>
      </blockquote>
    </div>
  );
}
